import React, { useState } from "react";
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Input, message, Spin } from "antd";
import { useHistory } from 'react-router-dom';
import api from "utils/api";
import { FormComponentProps } from '@ant-design/compatible/es/form';


interface Props extends FormComponentProps {

}

const QuoteForm = ({ form }: Props) => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();


    const handleClick = () => {
        history.push("/");
    }
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        form.validateFields((err, values) => {

            setLoading(true);
            api.requests.post(`/customer/quote/start/`, values).then(data => {
                window.localStorage.setItem("quote_token", data.quote_token);
                setLoading(false);
                api.requests.post(`/customer/quote/send-email-ppc/`, values).then(data => {
                }).catch(() => {
                }).finally(() => setLoading(false))

                history.push('/rapid-quote/');
            }).catch(() => {
                message.error('Error, try again please!');
            }).finally(() => setLoading(false))

            if (!err) {
                console.log(">> Received values of form: ", values);
            }
        });
    };

    const { getFieldDecorator } = form;

    return (
        <div className="w-full md:w-2/5">
            <Spin spinning={loading} className={"p-4"}>
                <Form onSubmit={handleSubmit}>
                    <h1 className="max-w-md  sq-description mt-5">
                        Start using the quote tool today for no cost to you. Enter a valid email
                        to save your progress and come back to it any time.
                    </h1>
                    <div className="flex flex-col sm:flex-row">
                        <Form.Item className="sm:flex-1" label="First name:">
                            {getFieldDecorator("first_name", {
                                rules: [
                                    { required: true, message: "Please input your first name!" },
                                ],
                            })(<Input />)}
                        </Form.Item>
                        <div className="hidden sm:inline px-2" />
                        <Form.Item className="sm:flex-1" label="Last name:">
                            {getFieldDecorator("last_name", {
                                rules: [
                                    { required: true, message: "Please input your last name!" },
                                ],
                            })(<Input />)}
                        </Form.Item>
                    </div>
                    <Form.Item label="Email:">
                        {getFieldDecorator("email", {
                            rules: [
                                {
                                    type: "email",
                                    required: true,
                                    message: "Please insert a valid email",
                                },
                            ],
                        })(<Input autoComplete="email" />)}
                    </Form.Item>
                    <div className="grid grid-cols-3 gap-4">
                        <Form.Item>
                            <Button
                                type="primary"
                                onClick={() => {
                                    //Todo redirect to 
                                    "return gtag_report_conversion('https://portal.parts-badger.com/your-online-machine-shop')"
                                }}
                                htmlType="submit">
                                Start quoting
                            </Button>
                            {/* <button type="submit" onClick="return gtag_report_conversion('https://portal.parts-badger.com/your-online-machine-shop')">Start quoting</button> */}
                        </Form.Item>
                        <div className="col-span-2">
                            <Form.Item>
                                <div>Do you already have an account?
                                    <Button type="link" onClick={handleClick}>
                                        login here
                                    </Button>
                                </div>
                            </Form.Item>
                        </div>
                    </div>
                    <div className="flex-1 flex mb-6  ">
                        <p className="max-w-md italic">
                            PartsBadger does not distribute or sell your email address. Your
                            email address may be used for account lookup, assistance,
                            troubleshooting, and communications regarding statuses and/or
                            requirements.
                        </p>
                    </div>
                </Form>
            </Spin>
        </div>
    );
};

export default Form.create({ name: "start_quoting" })(QuoteForm);